/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { xBaseTheme } from "@guestsupply/XDL/types";
import { color } from "@guestsupply/XDL/Utilities";
import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            ...OverflowMenuPresentationPropsDefault?.buttonProps,
            css: css`
                &:hover,
                &:focus {
                    background: transparent;
                    border: 1px solid ${color("primary.main")};
                }
            `,
        },
        cssOverrides: {
            menuItem: css`
                color: ${color("common.black")};
                &:disabled {
                    color: ${color("common.black", 0.33)};
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
